<div
  class="custom-switch"
  [id]="id"
  [class.disabled]="disabled"
  [class.tnt-switch]="isTrackAndTrace"
  [class.active]="isActive"
>
  @if (labelPosition === "left") {
    @if (label) {
      <span class="switch-label">{{ label }}</span>
    }
  }

  <svg
    width="45"
    height="21"
    viewBox="0 0 47 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    (click)="onToggleSwitch()"
    [class.tntSlider]="isTrackAndTrace"
  >
    @if (isActive && !isTrackAndTrace) {
      <ng-container>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.72801e-05 12.3C5.72801e-05 5.5069 5.50695 0 12.3001 0H34.7605C41.5536 0 47.0605 5.5069 47.0605 12.3C47.0605 19.0931 41.5536 24.6 34.7605 24.6H12.3001C5.50695 24.6 5.72801e-05 19.0931 5.72801e-05 12.3ZM11.0161 19C14.8821 19 18.0161 15.866 18.0161 12C18.0161 8.13401 14.8821 5 11.0161 5C7.15012 5 4.01611 8.13401 4.01611 12C4.01611 15.866 7.15012 19 11.0161 19Z"
          [attr.fill]="customColorInside ? customColorInside : '#679EC6'"
        />
      </ng-container>
    }
    @if (!isActive && !isTrackAndTrace) {
      <ng-container>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1731 0C5.89779 0 0 5.89779 0 13.1731C0 20.4484 5.89777 26.3462 13.1731 26.3462H33.6346C40.9099 26.3462 46.8077 20.4484 46.8077 13.1731C46.8077 5.89779 40.9099 0 33.6346 0H13.1731ZM1.5 13.1731C1.5 6.72622 6.72621 1.5 13.1731 1.5H33.6346C40.0815 1.5 45.3077 6.72621 45.3077 13.1731C45.3077 19.6199 40.0815 24.8462 33.6346 24.8462H13.1731C6.7262 24.8462 1.5 19.6199 1.5 13.1731ZM27.8077 13.1731C27.8077 9.95496 30.4165 7.34615 33.6346 7.34615C36.8527 7.34615 39.4615 9.95496 39.4615 13.1731C39.4615 16.3912 36.8527 19 33.6346 19C30.4165 19 27.8077 16.3912 27.8077 13.1731ZM33.6346 5.84615C29.5881 5.84615 26.3077 9.12653 26.3077 13.1731C26.3077 17.2196 29.5881 20.5 33.6346 20.5C37.6812 20.5 40.9615 17.2196 40.9615 13.1731C40.9615 9.12653 37.6812 5.84615 33.6346 5.84615Z"
          [attr.fill]="customColorOutline ? customColorOutline : '#979797'"
        />
      </ng-container>
    }
    @if (isActive && isTrackAndTrace) {
      <ng-container>
        <rect
          x="0.180908"
          y="0.589722"
          width="40.236"
          height="16.7182"
          rx="8.35911"
          fill="#2DCE89"
        />
        <circle cx="9.41675" cy="9.14502" r="6" fill="#EEEEF3" />
      </ng-container>
    }
    @if (!isActive && isTrackAndTrace) {
      <ng-container>
        <rect
          x="0.180908"
          y="0.589722"
          width="40.236"
          height="16.7182"
          rx="8.35911"
          fill="#C6C6C6"
        />
        <circle cx="31.4167" cy="9.14502" r="6" fill="#59618E" />
      </ng-container>
    }
  </svg>

  @if (labelPosition === "right") {
    @if (label) {
      <span class="switch-label" style="margin-left: 3px">{{ label }}</span>
    }
  }
</div>
